/* eslint-disable */
// i18n setup — bilingual EN / SW (Kiswahili) for the citizen portal.
// Language preference is persisted to localStorage so a returning
// customer keeps whatever they picked last time.
import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import sw from './locales/sw.json';

export const AVAILABLE_LOCALES = [
  { code: 'en', label: 'English' },
  { code: 'sw', label: 'Kiswahili' },
];

const STORAGE_KEY = 'ss.locale';

function detectInitialLocale() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && AVAILABLE_LOCALES.some(l => l.code === saved)) return saved;
  } catch (_) {}
  const nav = (navigator.language || 'en').toLowerCase();
  return nav.startsWith('sw') ? 'sw' : 'en';
}

const i18n = createI18n({
  legacy: false,          // Composition API + Options API both supported
  globalInjection: true,  // enables $t everywhere in templates
  locale: detectInitialLocale(),
  fallbackLocale: 'en',
  messages: { en, sw },
});

export function setLocale(code) {
  if (!AVAILABLE_LOCALES.some(l => l.code === code)) return;
  i18n.global.locale.value = code;
  try { localStorage.setItem(STORAGE_KEY, code); } catch (_) {}
  document.documentElement.setAttribute('lang', code);
}

export default i18n;
